import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useSnackbar } from "igfd-commons/src/snackbar";

import { ReduxState } from "@dashboard/types/reduxState";

/**
 * Component that uses the snackbar to show non fatal errors
 * to the user.
 *
 * These can be 400 errors, or network errors, that the user must
 * be informed about and would like to retry.
 */
export const ErrorInformer = () => {
  const snackbar = useSnackbar();

  const dispatch = useDispatch();

  const errorsInStore = useSelector((state: ReduxState) => state.error.errors);

  useEffect(() => {
    errorsInStore.forEach(({ errorId, message, isUserFacing }) => {
      if (errorId && message) {
        if (isUserFacing) {
          snackbar.error(message);
        } else {
          snackbar.error("Something went wrong, please try again later");
        }
        console.error("ErrorInformer caught an error", errorId, message);
        dispatch({ type: "REMOVE_ERROR", errorId });
      }
    });
  }, [errorsInStore, dispatch, snackbar]);

  return null;
};
